module.exports = __webpack_public_path__ + "static/media/antigua-beaches-51.5a07b069.jpg";